export const UPDATE_QUICK_QUIZ_DATA = "UPDATE_QUICK_QUIZ_DATA";
export const SET_QUICK_QUIZ_ID = "SET_QUICK_QUIZ_ID";
export const SET_QUICK_QUIZ_LANGUAGE_ID = "SET_QUICK_QUIZ_LANGUAGE_ID";
export const RESET_QUICK_QUIZ_DATA = "RESET_QUICK_QUIZ_DATA";
export const SET_QUICK_QUIZ_MASTER_FLAG = "SET_QUICK_QUIZ_MASTER_FLAG";
